import React from 'react';
import { bonuses } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-17" data-mp="plslc7o6v6at">
      <div className="mx-auto max-w-6xl" data-id="element-18" data-mp="aua8giqmlrvo">
        <SectionHeading eyebrow="Incluidos hoy gratis" title={<>
              5 bonos <span className="text-brand" data-id="element-20" data-mp="fs3cp68dcbtb">exclusivos</span>
            </>} subtitle="Se suman al kit sin costo extra, pensados para los días en que nada sale como estaba planeado." data-id="element-19" data-mp="fu6cghzbpjb8" />

        <ol className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="5xjtxzugz4cd">
          {bonuses.map((bonus, index) => <Reveal key={bonus.title} delay={index * 0.04} className="h-full" data-id="element-22" data-mp="3o369yhbo54hb" data-mpi={index}>
              <li className="flex h-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-bone transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-23" data-mp="3t1rdapm7w49z">
                <div className="relative border-b-2 border-ink bg-white" data-id="element-24" data-mp="1r9v0zds86qe5">
                  <img src={bonus.cover} alt="" loading="lazy" className="mx-auto block h-56 w-full object-contain" data-id="element-25" data-mp="1r6yyrd9chfjw" />
                  <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 font-display text-xs tracking-[0.1em] text-volt" data-id="element-26" data-mp="3dfld14naiu0w">
                    Bono {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-27" data-mp="3n5ojo7nc46hp">
                  <h3 className="font-display text-xl leading-tight text-ink" data-id="element-28" data-mp="2zf2bmgdbym7p">
                    {bonus.title}
                  </h3>
                  <p className="mt-3 flex-1 text-base leading-relaxed text-ink/70" data-id="element-29" data-mp="2ui24010u1beh">
                    {bonus.text}
                  </p>
                  <p className="mt-5 flex flex-wrap items-center gap-2 text-sm font-bold" data-id="element-30" data-mp="33h5nv77tpuu1">
                    <span className="text-ink/40 line-through" data-id="element-31" data-mp="33jidm6jtp9hn">
                      Valor {bonus.was}
                    </span>
                    <span className="rounded-full bg-volt px-3 py-1 font-display text-xs tracking-[0.1em] text-ink" data-id="element-32" data-mp="irgakymrqh3g">
                      Gratis
                    </span>
                  </p>
                </div>
              </li>
            </Reveal>)}

          <Reveal delay={0.24} className="h-full" data-id="element-33" data-mp="3hk3zcpv2kkqc">
            <li className="flex h-full flex-col items-start justify-center rounded-2xl border-2 border-ink bg-brand p-8 text-white" data-id="element-34" data-mp="3ljcu9y1uionh">
              <p className="font-display text-sm tracking-[0.14em] text-white/80" data-id="element-35" data-mp="3qi5y0yrbz1ag">
                Los 5 bonos
              </p>
              <p className="mt-3 font-display text-5xl leading-none" data-id="element-36" data-mp="2tqlvpgwownv2">
                Incluidos gratis
              </p>
              <p className="mt-4 text-base leading-relaxed text-white/85" data-id="element-37" data-mp="32slbk5vyxlwf">
                Se suman hoy al kit completo, sin cargo adicional.
              </p>
            </li>
          </Reveal>
        </ol>
      </div>
    </section>;
}